import store from '@/store'
import authStore from '@/modules/auth/auth.store'
import { getModule } from 'vuex-module-decorators'
import router from '@/router'

export default async function requestLogin(callback: Function) {
  const authModule = getModule(authStore, store)

  if (authModule.hasLoggedIn) {
    callback()
    return
  }

  try {
    await authModule.signIn()
    await authModule.updateLoginState()
  } catch (err) {
    console.error('Request login failed.', err)
    return
  }

  if (authModule.hasLoggedIn) {
    callback()
  }
}
